import { render, staticRenderFns } from "./menu1_active_learning.vue?vue&type=template&id=55d9a3ae&scoped=true"
import script from "./menu1_active_learning.vue?vue&type=script&lang=js"
export * from "./menu1_active_learning.vue?vue&type=script&lang=js"
import style0 from "./menu1_active_learning.vue?vue&type=style&index=0&id=55d9a3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d9a3ae",
  null
  
)

export default component.exports